import type { AgreementsActivityResult } from '../../activity-handler/agreements-activity.types';
import { fetchMaterialSummaryActivity } from '../api/fetch-material-summary-activity';
import type { MaterialSummaryPayload } from '../models/material-summary.model';

/** Injected collaborators for {@link fetchMaterialSummaryReport} (composition root / tests). */
export interface MaterialSummaryReportFetchDeps {
    fetchMaterialSummaryActivity(
        accessToken: string,
        payload: MaterialSummaryPayload
    ): Promise<AgreementsActivityResult>;
}

export const defaultMaterialSummaryReportFetchDeps: MaterialSummaryReportFetchDeps = {
    fetchMaterialSummaryActivity,
};
